import type { FlexProps } from '@chakra-ui/react';
import { useToken } from '@chakra-ui/react';
import type { BigNumber } from '@ethersproject/bignumber';
import { formatUnits } from '@ethersproject/units';
import { useTranslations } from '@ui/i18n';

import type { AllocationPieChartProps } from './AllocationPieChart';
import { AllocationPieChart } from './AllocationPieChart';

export type VaultsPieChartProps = {
  month3: BigNumber | undefined;
  month12: BigNumber | undefined;
  month48: BigNumber | undefined;
  month96: BigNumber | undefined;
} & FlexProps;
export const VaultsPieChart = ({
  month3,
  month12,
  month48,
  month96,
  ...props
}: VaultsPieChartProps) => {
  const t = useTranslations();
  const [month6Color, month12Color, month24Color, month48Color] = useToken(
    'colors',
    ['vaults-month6', 'vaults-month12', 'vaults-month24', 'vaults-month48'],
  );
  const chartData: AllocationPieChartProps['data'] = [
    {
      name: t('{num} Months', {
        num: 3,
      }),
      color: month6Color,
      y: month3 ? Number(formatUnits(month3, 'ether')) : 0,
    },
    {
      name: t('{num} Months', {
        num: 12,
      }),
      color: month12Color,
      y: month12 ? Number(formatUnits(month12, 'ether')) : 0,
    },
    {
      name: t('{num} Months', {
        num: 48,
      }),
      color: month24Color,
      y: month48 ? Number(formatUnits(month48, 'ether')) : 0,
    },
    {
      name: t('{num} Months', {
        num: 96,
      }),
      color: month48Color,
      y: month96 ? Number(formatUnits(month96, 'ether')) : 0,
    },
  ];
  return <AllocationPieChart data={chartData} {...props} />;
};
